import React, { useState } from "react";
import InputBox from "../../Component/UI/InputBox";
import AddButton from "../../Component/UI/AddButton";
export default function AddUserModal({ onClose, onSubmit }) {


  const fields = [
    { label: "Team Name", name: "name" }
  ];


  const [form, setForm] = React.useState({
    name: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };


  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Modal Container */}
      <div className="relative bg-white w-full max-w-3xl rounded-2xl p-8 z-10">
        {/* Title */}
        <h2 className="text-xl font-semibold mb-4">Create New Team</h2>

        {/* Form */}
        <div className="space-y-4">
          {fields.map(({ label, name }) => (
            <InputBox
              key={name}
              label={label}
              name={name}
              value={form[name]}
              onChange={handleChange}
            />
          ))}
        </div>

        <div className="flex justify-end gap-4 mt-8">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">Cancel</button>
          <AddButton title="Create" className="bgcolor text-white px-6" onClick={() => onSubmit(form)} />
        </div>


      </div>

    </div>
  );
}
